module.exports = __webpack_public_path__ + "static/media/surveyLanding.e7fa622c.png";